import soundManager from "./SoundManager";

function getZoneAlertLabel(eventType) {
  if (eventType === "market_in_zone") {
    return "Zone Active";
  }

  if (eventType === "spike_detected") {
    return "Spike Confirmed";
  }

  if (eventType === "zone_failed") {
    return "Zone Failed";
  }

  return "Zone Approaching";
}

export function deliverZoneAlert({ eventType, symbol, timeframeLabel, zoneType, price }) {
  soundManager.play(eventType);

  if (typeof document !== "undefined" && document.visibilityState === "visible") {
    return;
  }

  if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
    navigator.vibrate([200, 100, 200]);
  }

  if (typeof Notification === "undefined" || Notification.permission !== "granted") {
    return;
  }

  try {
    new Notification(getZoneAlertLabel(eventType), {
      body: `${symbol || ""} ${timeframeLabel || ""} ${zoneType || ""}${
        Number.isFinite(Number(price)) ? ` at ${Number(price).toFixed(2)}` : ""
      }`.trim(),
      icon: "/icon.png",
    });
  } catch (error) {}
}
